/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import Hightlighter from 'react-highlight-words';
import * as S from './ChooseSpecificVersions.styled';
import { Checkbox } from 'components';

export const Content = ({ foundedVersions, search, isActive, toggle }) => {
  const activeItems = useMemo(() => {
    return foundedVersions.filter(({ value }) => isActive(value));
  }, [foundedVersions]);
  const deActiveItems = useMemo(() => {
    return foundedVersions.filter(({ value }) => !isActive(value));
  }, [foundedVersions]);

  return (
    <div style={{ paddingTop: '8px' }}>
      {[...activeItems, ...deActiveItems]?.map(({ label, value }) => (
        <S.Group key={value}>
          <S.Row onClick={() => toggle(true, value)}>
            <Checkbox id={`${value}`} isChecked={isActive(value)} name={value} onChange={toggle} />
            <S.GroupName>
              <Hightlighter textToHighlight={label} searchWords={[search]} highlightTag='strong' />
            </S.GroupName>
          </S.Row>
        </S.Group>
      ))}
    </div>
  );
};
